import React from 'react';
import { Link } from 'react-router-dom';

const bulletStyle = {
  fontSize: '16px',
  lineHeight: '1.6',
  marginBottom: '10px',
  paddingLeft: '20px',
  textIndent: '-12px'
};
const headingStyle = {
    fontSize: '3rem',
    fontWeight: '500',
    // marginTop: '20px',
    marginBottom: '10px',
    color:'#44413e'
  };
const sectionTitleStyle = {
  fontSize: '2.1rem',
    fontWeight: '500',
    marginTop: '20px',
    marginBottom: '10px',
    color:'#44413e'
};

const paragraphStyle = {
  lineHeight: '1.8',
  marginBottom: '10px'
};

const PrivacyPolicy = () => {
  return (
    <div style={{padding: '2rem', lineHeight: '1.8', maxWidth: '900px', margin: '0 auto', marginTop:'10rem' }}>
      <div style={headingStyle}>
        Privacy Policy
      </div>

      <p style={paragraphStyle}>
        This privacy policy sets out how Kidorise uses and protects any information that you deliver to Kidorise when you use this website <Link style={{textTransform:'none'}}>https://kidorise.in/</Link>.
      </p>

      <p style={paragraphStyle}>
        Kidorise is committed to ensuring that your privacy is protected. If we ask you to provide information by which you can be identified, you can be assured that it will only be used in accordance with this privacy statement.
      </p>

      <p style={paragraphStyle}>
        Kidorise may update this policy from time to time by updating this page. Please check this page regularly to ensure you are happy with any changes.
      </p>

      <div style={sectionTitleStyle}>What we collect</div>
      <div style={bulletStyle}>• Name and job title</div>
      <div style={bulletStyle}>• Contact information including email address</div>
      <div style={bulletStyle}>• Demographic information such as postal code, preferences and interests</div>
      <div style={bulletStyle}>• Other information relevant to customer surveys and/or offers</div>

      <div style={sectionTitleStyle}>What we do with the information we gather</div>
      <p style={paragraphStyle}>We require this information to understand your needs and provide better service, including the following:</p>
      <div style={bulletStyle}>• Internal record keeping</div>
      <div style={bulletStyle}>• To improve our products and services</div>
      <div style={bulletStyle}>• To periodically send promotional emails using the email address you provided</div>
      <div style={bulletStyle}>• To contact you for market research via email, phone, or mail</div>
      <div style={bulletStyle}>• To customize the website according to your interests</div>

      <div style={sectionTitleStyle}>Consent for Communication</div>
      <p style={paragraphStyle}>
        When you consent, we may use your communications to manage our relationship and send information about products/offers/services through various channels such as email, SMS, calls, push notifications, and social media.
      </p>

      <div style={sectionTitleStyle}>Cookies</div>
      <div style={bulletStyle}>• Cookies help us analyze data about web page traffic and improve our website for your needs</div>
      <div style={bulletStyle}>• A cookie does not give us access to your computer or personal information unless shared by you</div>
      <div style={bulletStyle}>• You can choose to accept or decline cookies in your browser settings</div>

      <div style={sectionTitleStyle}>Links to Other Websites</div>
      <p style={paragraphStyle}>
        Our website may contain links to other websites. We are not responsible for the protection of your data on those sites. You should review their privacy statements separately.
      </p>

      <div style={sectionTitleStyle}>Controlling Your Personal Information</div>
      <p style={paragraphStyle}>
        You may choose to restrict the collection or use of your personal data in the following ways:
      </p>
      <div style={bulletStyle}>• Opt out of direct marketing by checking opt-out boxes on forms</div>
      <div style={bulletStyle}>• Contact us to update or remove your marketing preferences</div>
      <div style={bulletStyle}>• We will not sell, distribute, or lease your personal information without your permission</div>
      <div style={bulletStyle}>• You may request details of the personal information we hold about you under the Data Protection Act 1998</div>
      <div style={bulletStyle}>• If you believe any information is incorrect, please email us and we will correct it promptly</div>

      <div style={sectionTitleStyle}>Contacting Us</div>
      <p style={paragraphStyle}>
        If you have any questions regarding this privacy policy, contact us using the information below:
      </p>
      <div style={bulletStyle}><strong>Divine Industries</strong></div>
      <div style={bulletStyle}>Phone: 9953110193</div>
      <div style={bulletStyle}>Email: <Link style={{textTransform:'none'}}>kidorise9@gmail.com</Link></div>
    </div>
  );
};

export default PrivacyPolicy;
